"use strict";import{DialogWrapper as e}from"./src/DialogWrapper.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-dialog-wrapper",e);
//# sourceMappingURL=sp-dialog-wrapper.js.map
